import { Flame, Leaf, Clock, Wind } from "lucide-react";

const services = [
  {
    icon: Flame,
    title: "Fire Prevention",
    text: "Lint is highly flammable. The U.S. Fire Administration links 2,900+ home fires per year to clogged dryer vents. Regular cleaning is your #1 defense.",
  },
  {
    icon: Leaf,
    title: "Lower Energy Bills",
    text: "A clogged vent forces your dryer to work overtime. Our deep cleans typically cut drying times in half and reduce energy use by 20–30%.",
  },
  {
    icon: Clock,
    title: "Extends Dryer Life",
    text: "Restricted airflow burns out motors and heating elements. A clean vent can add 2–5 years to the life of your dryer.",
  },
  {
    icon: Wind,
    title: "Better Indoor Air",
    text: "Eliminate the musty, damp smell and reduce allergens. Your laundry room (and home) will smell noticeably fresher.",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="border-b border-slate-200 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="bid-divider" />
              <span className="bid-eyebrow">Why it matters</span>
            </div>
            <h2 className="font-display font-bold text-4xl sm:text-5xl tracking-tight leading-tight">
              A 30-minute service that
              <br />
              protects your entire home.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-lg text-slate-700 leading-relaxed">
              Most homeowners don&apos;t think about their dryer vent until it&apos;s too
              late. Our certified technicians thoroughly clean the full vent
              line — not just the lint trap — and provide a written safety
              report after every job.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-0 border border-slate-200">
          {services.map((s, idx) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${idx}`}
                className={`p-8 lg:p-10 bg-white relative ${
                  idx !== services.length - 1
                    ? "border-b md:border-b md:border-r-0 lg:border-b-0 lg:border-r border-slate-200"
                    : ""
                } ${idx > 0 && idx < services.length - 1 ? "md:border-r md:border-slate-200" : ""}`}
              >
                <div className="w-12 h-12 bg-slate-900 text-white flex items-center justify-center mb-6">
                  <Icon size={22} />
                </div>
                <div className="font-display font-bold text-xl uppercase tracking-tight mb-3">
                  {s.title}
                </div>
                <p className="text-slate-600 leading-relaxed">{s.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
